var _g, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChoose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 192,
    viewBox: "0 0 467 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1506_143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446 57H26V140H446V57Z",
    fill: "#D7CDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.136 32.5159H53.5208C49.721 32.5159 46.6406 35.5955 46.6406 39.3944V155.841C46.6406 159.639 49.721 162.719 53.5208 162.719H157.136C160.936 162.719 164.016 159.639 164.016 155.841V39.3944C164.016 35.5955 160.936 32.5159 157.136 32.5159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.251 32.5159H187.636C183.836 32.5159 180.756 35.5955 180.756 39.3944V155.841C180.756 159.639 183.836 162.719 187.636 162.719H291.251C295.051 162.719 298.131 159.639 298.131 155.841V39.3944C298.131 35.5955 295.051 32.5159 291.251 32.5159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.36 32.5159H321.744C317.944 32.5159 314.864 35.5955 314.864 39.3944V155.841C314.864 159.639 317.944 162.719 321.744 162.719H425.36C429.159 162.719 432.24 159.639 432.24 155.841V39.3944C432.24 35.5955 429.159 32.5159 425.36 32.5159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.251 32.5159H187.636C183.836 32.5159 180.756 35.5955 180.756 39.3944V155.841C180.756 159.639 183.836 162.719 187.636 162.719H291.251C295.051 162.719 298.131 159.639 298.131 155.841V39.3944C298.131 35.5955 295.051 32.5159 291.251 32.5159Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.236 119.103H289.559",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.145 71.1387H359.104V78.0172H414.145V71.1387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.145 80.7686H359.104V119.288H414.145V80.7686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M414.145 80.7686H359.227V80.7617H331.583V119.281H359.103L359.365 91.7673L359.255 82.8321H414.145V80.7686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M359.104 71.1387H331.583V78.0172H329.519V80.7686L331.583 80.7617H359.193L359.104 71.1387Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M359.103 119.288H331.583V80.7686H359.103V119.288Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.145 119.288H359.104V80.7686H414.145V119.288Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.145 71.1387H359.104V78.0172H414.145V71.1387Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.583 71.1387H359.103V78.0172H331.583V71.1387Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.209 78.0171H357.728V80.7685H416.209V78.0171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.079 119.288H421.025",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.265 119.288V95.9012C407.265 93.712 406.395 91.6127 404.846 90.0647C403.298 88.5167 401.198 87.647 399.008 87.647C396.819 87.647 394.719 88.5167 393.17 90.0647C391.622 91.6127 390.752 93.712 390.752 95.9012V119.288H407.265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.496 106.907V95.9012C382.496 93.712 381.626 91.6127 380.078 90.0647C378.529 88.5167 376.43 87.647 374.24 87.647C372.05 87.647 369.95 88.5167 368.402 90.0647C366.854 91.6127 365.984 93.712 365.984 95.9012V106.907H382.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.223 106.907H338.463V94.5255C338.463 92.7012 339.188 90.9516 340.478 89.6617C341.768 88.3717 343.518 87.647 345.343 87.647C347.168 87.647 348.918 88.3717 350.208 89.6617C351.498 90.9516 352.223 92.7012 352.223 94.5255V106.907Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.008 87.647C398.663 87.6489 398.319 87.6719 397.976 87.7158C399.971 87.967 401.805 88.9371 403.135 90.4441C404.465 91.951 405.2 93.8914 405.2 95.9012V119.288H407.265V95.9012C407.265 93.712 406.395 91.6127 404.846 90.0647C403.298 88.5167 401.198 87.647 399.008 87.647Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.24 87.647C373.895 87.6489 373.55 87.6719 373.208 87.7158C375.202 87.967 377.037 88.9371 378.367 90.4441C379.697 91.951 380.431 93.8914 380.432 95.9012V106.907H382.496V95.9012C382.496 93.712 381.626 91.6127 380.078 90.0647C378.529 88.5167 376.429 87.647 374.24 87.647Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.265 119.288V95.9012C407.265 93.712 406.395 91.6127 404.846 90.0647C403.298 88.5167 401.198 87.647 399.008 87.647C396.819 87.647 394.719 88.5167 393.17 90.0647C391.622 91.6127 390.752 93.712 390.752 95.9012V119.288H407.265Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.496 106.907V95.9012C382.496 93.712 381.626 91.6127 380.078 90.0647C378.529 88.5167 376.43 87.647 374.24 87.647C372.05 87.647 369.95 88.5167 368.402 90.0647C366.854 91.6127 365.984 93.712 365.984 95.9012V106.907H382.496Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.209 78.0171H329.519V80.7685H416.209V78.0171Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.36 32.5159H321.744C317.944 32.5159 314.864 35.5955 314.864 39.3944V155.841C314.864 159.639 317.944 162.719 321.744 162.719H425.36C429.159 162.719 432.24 159.639 432.24 155.841V39.3944C432.24 35.5955 429.159 32.5159 425.36 32.5159Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.683 91.0864H125.171V119.288H141.683V91.0864Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.867 98.6526H129.987V100.317H136.867V98.6526Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.136 32.5159H53.5208C49.721 32.5159 46.6406 35.5955 46.6406 39.3944V155.841C46.6406 159.639 49.721 162.719 53.5208 162.719H157.136C160.936 162.719 164.016 159.639 164.016 155.841V39.3944C164.016 35.5955 160.936 32.5159 157.136 32.5159Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.81 69.7629H93.522V86.2713H150.634V83.5199L134.81 69.7629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.522 88.335V86.2715H148.563V88.335",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5219 86.2715H66.0012V119.288H93.5219V86.2715Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.522 86.2715H148.57V119.288H93.522",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M93.522 83.5199V69.7629H79.7616L63.9373 83.5199V86.2713H66.0013V119.288H93.522L93.6458 86.2713H150.627V83.5199H93.522Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1211 119.288H155.443",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6419 91.0864H72.8816V112.41H86.6419V91.0864Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.683 91.0864H125.171V119.288H141.683V91.0864Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.603 91.0864H99.7141V112.41H117.603V91.0864Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.291 91.0864H99.0261V96.5892H118.291V91.0864Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.059 91.0864H123.795V93.8378H143.059V91.0864Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0178 91.0864H71.5054V96.5892H88.0178V91.0864Z",
    fill: "#DDDDDD",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.867 98.6526H129.987V104.843H136.867V98.6526Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.81 69.7629H93.522V86.2713H150.634V83.5199L134.81 69.7629Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7616 69.7629H93.5219V83.5199V86.2713H63.9441V83.5199L79.7616 69.7629Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.684 64.728H260.407L236.533 84.0841V119.103H198.809V84.0841L222.684 64.728Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.05 92.3381H254.532V119.102H257.05V92.3381Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.002 92.3381H274.484V106.721H277.002V92.3381Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.533 119.103V84.0841L260.407 64.728L283.986 83.7884V119.103H236.533Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.809 119.103V84.0841L222.684 64.728H260.407L236.533 84.0841V119.103H198.809Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.809 84.084H236.533",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.829 93.7139H203.625V106.721H213.829V93.7139Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.717 93.7139H221.514V106.721H231.717V93.7139Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.057 92.3381H243.413V119.102H257.057V92.3381Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.009 92.3381H263.366V106.721H277.009V92.3381Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.373 73.7044C260.177 73.7079 259.982 73.7217 259.788 73.7457C260.926 73.882 261.974 74.4305 262.735 75.2874C263.496 76.1442 263.916 77.2499 263.916 78.3956V84.6413H265.093V78.4163C265.095 77.7962 264.975 77.1817 264.739 76.6083C264.503 76.035 264.155 75.5141 263.716 75.0759C263.277 74.6378 262.756 74.291 262.182 74.0556C261.608 73.8202 260.993 73.7008 260.373 73.7044Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.093 84.6411V78.416C265.093 77.1719 264.598 75.9786 263.718 75.0989C262.838 74.2191 261.645 73.7249 260.401 73.7249V73.7249C259.785 73.7249 259.175 73.8462 258.606 74.082C258.037 74.3179 257.52 74.6637 257.085 75.0994C256.65 75.5351 256.305 76.0522 256.07 76.6213C255.835 77.1905 255.714 77.8003 255.715 78.416V84.6618L265.093 84.6411Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.484 135.205H201.396",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.078 135.205H335.504",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.615 135.205H67.281",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.1035,
    cy: 36.1035,
    r: 36.1035,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0315 45.146V42.728C31.1408 41.8093 32.2155 40.8993 33.2555 39.998C34.3128 39.0967 35.2488 38.204 36.0635 37.32C36.8955 36.436 37.5542 35.578 38.0395 34.746C38.5422 33.8967 38.7935 33.0733 38.7935 32.276C38.7935 31.5307 38.5855 30.872 38.1695 30.3C37.7708 29.728 37.1035 29.442 36.1675 29.442C35.2142 29.442 34.4948 29.754 34.0095 30.378C33.5242 31.002 33.2815 31.756 33.2815 32.64H30.0575C30.0922 31.3053 30.3868 30.196 30.9415 29.312C31.4962 28.4107 32.2328 27.7433 33.1515 27.31C34.0702 26.8593 35.1015 26.634 36.2455 26.634C38.1002 26.634 39.5388 27.1453 40.5615 28.168C41.6015 29.1733 42.1215 30.482 42.1215 32.094C42.1215 33.0993 41.8875 34.0787 41.4195 35.032C40.9688 35.9853 40.3708 36.904 39.6255 37.788C38.8802 38.672 38.0742 39.504 37.2075 40.284C36.3408 41.0467 35.5002 41.7573 34.6855 42.416H42.5635V45.146H30.0315Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M454.042 146.065C453.688 145.229 453.023 144.562 452.187 144.206C451.351 143.85 450.409 143.832 449.56 144.156C448.71 144.48 448.02 145.12 447.634 145.943C447.247 146.765 447.195 147.706 447.488 148.566L446.871 146.948C446.493 145.957 445.736 145.156 444.767 144.723C443.799 144.289 442.698 144.258 441.706 144.636C440.714 145.015 439.914 145.771 439.48 146.74C439.046 147.708 439.015 148.809 439.393 149.801L438.411 147.226C438.008 146.269 437.249 145.505 436.294 145.097C435.338 144.688 434.262 144.667 433.291 145.038C432.32 145.408 431.531 146.141 431.091 147.082C430.65 148.022 430.592 149.098 430.929 150.08L423.562 130.769C423.179 129.86 422.457 129.135 421.549 128.747C420.641 128.36 419.618 128.34 418.696 128.692C417.774 129.044 417.024 129.74 416.605 130.633C416.186 131.527 416.13 132.549 416.45 133.483L424.472 154.51L422.033 159.963C421.611 160.901 421.379 161.913 421.349 162.941C421.319 163.969 421.493 164.992 421.86 165.953L424.412 172.643C425.016 174.225 425.968 175.651 427.199 176.815C428.429 177.979 429.906 178.85 431.52 179.365C433.031 179.845 434.414 180.659 435.566 181.747C436.719 182.835 437.611 184.169 438.176 185.65L439.175 188.268L460.353 180.188L458.955 176.523C457.621 173.019 457.328 169.204 458.113 165.538C458.895 161.871 458.603 158.057 457.27 154.552L455.427 149.721L454.042 146.065Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M430.654 149.345L433.455 156.687",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M430.644 149.333L423.559 130.761C423.381 130.294 423.112 129.867 422.769 129.504C422.426 129.141 422.015 128.849 421.559 128.645C421.103 128.441 420.612 128.329 420.112 128.315C419.613 128.301 419.116 128.385 418.649 128.563V128.563C417.706 128.923 416.944 129.642 416.531 130.563C416.118 131.484 416.088 132.531 416.446 133.474L428.934 166.208",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M438.877 148.449L438.898 148.505",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M424.469 154.501L422.03 159.954C421.608 160.892 421.375 161.904 421.346 162.932C421.316 163.96 421.49 164.983 421.857 165.944L424.409 172.634C425.013 174.216 425.965 175.642 427.196 176.806C428.426 177.97 429.903 178.841 431.517 179.356V179.356C433.028 179.836 434.411 180.65 435.563 181.738C436.715 182.826 437.607 184.16 438.173 185.641L439.171 188.259L460.35 180.179L458.952 176.514C457.617 173.01 457.325 169.195 458.109 165.529C458.892 161.862 458.6 158.048 457.267 154.544L454.441 147.137",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M431.395 151.303L430.929 150.08C430.551 149.089 430.582 147.988 431.016 147.019C431.449 146.051 432.25 145.294 433.242 144.916C433.733 144.728 434.256 144.639 434.782 144.653C435.307 144.667 435.825 144.785 436.305 145C436.785 145.214 437.218 145.521 437.579 145.903C437.941 146.285 438.223 146.735 438.411 147.226L439.393 149.801",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M442.317 157.465L439.393 149.801C439.015 148.809 439.046 147.708 439.48 146.74C439.913 145.771 440.714 145.015 441.706 144.636C442.697 144.258 443.798 144.289 444.767 144.723C445.736 145.156 446.492 145.957 446.87 146.948L447.339 148.175",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M450.083 155.368L447.488 148.566C447.158 147.697 447.186 146.732 447.567 145.883C447.947 145.035 448.649 144.372 449.518 144.04V144.04C450.387 143.71 451.351 143.738 452.199 144.118C453.047 144.497 453.71 145.198 454.042 146.065L455.419 149.674",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1506_143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 140,
    fill: "white",
    transform: "translate(26 32)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoose);
export default __webpack_public_path__ + "static/media/Choose.1aadbd3b599501067305eb1584a56ae1.svg";
export { ForwardRef as ReactComponent };